import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { createPortal } from 'react-dom';
import { getThemeDataAttribute } from '../ThemeProvider/styles';
import { ThemeContext } from '@emotion/react';

/** Accepts any additional HTML attributes. */
var Portal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Portal, _React$Component);

  function Portal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "context", void 0);

    _defineProperty(_assertThisInitialized(_this), "_portalNode", null);

    _defineProperty(_assertThisInitialized(_this), "_needsUpdate", false);

    _defineProperty(_assertThisInitialized(_this), "_updated", false);

    return _this;
  }

  var _proto = Portal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var secondChild = this._getSecondChild();

    if (secondChild) {
      this._setupPortal();

      this._updatePortal();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var secondChild = this._getSecondChild();

    if (secondChild && !this._portalNode) {
      this._setupPortal();
    } else if (!secondChild && this._portalNode) {
      this._destroyPortal();
    }

    if (secondChild) {
      this._updatePortal();
    }

    if (this._needsUpdate) {
      if (this._updated) {
        if (this.props.onUpdate) {
          this.props.onUpdate();
        }

        this._updated = false;
        this._needsUpdate = false;
      } else {
        this.forceUpdate();
        this._updated = true;
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._destroyPortal();
  };

  _proto._getSecondChild = function _getSecondChild() {
    return React.Children.toArray(this.props.children)[1];
  };

  _proto._getRenderToNode = function _getRenderToNode() {
    var renderTo = this.props.renderTo;

    if (typeof renderTo === 'string') {
      return document.querySelector(renderTo);
    } else {
      return renderTo || document.body;
    }
  };

  _proto._setupPortal = function _setupPortal() {
    if (typeof document !== 'undefined') {
      this._portalNode = document.createElement(this.props.renderTag);

      this._getRenderToNode().appendChild(this._portalNode);

      if (this.props.getPortalNode) {
        this.props.getPortalNode(this._portalNode);
      }
    }

    this.forceUpdate();
    this._needsUpdate = true;
  };

  _proto._updatePortal = function _updatePortal() {
    var _this2 = this;

    var _this$props = this.props,
        renderTo = _this$props.renderTo,
        renderTag = _this$props.renderTag,
        onUpdate = _this$props.onUpdate,
        getPortalNode = _this$props.getPortalNode,
        style = _this$props.style,
        children = _this$props.children,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["renderTo", "renderTag", "onUpdate", "getPortalNode", "style", "children"]);

    Object.keys(restProps).forEach(function (key) {
      _this2._portalNode.setAttribute(key, restProps[key]);
    });

    this._portalNode.classList.add('tapestry-react-reset');

    this._portalNode.setAttribute(getThemeDataAttribute(this.context.id), 'true');

    if (style) {
      Object.keys(style).forEach(function (key) {
        _this2._portalNode.style[key] = style[key];
      });
    }
  };

  _proto._renderPortal = function _renderPortal(component) {
    return /*#__PURE__*/createPortal(component, this._portalNode);
  };

  _proto._destroyPortal = function _destroyPortal() {
    if (this._portalNode) {
      this._portalNode.parentNode.removeChild(this._portalNode);

      if (this.props.getPortalNode) {
        this.props.getPortalNode(null);
      }
    }

    this._portalNode = null;
  };

  _proto.render = function render() {
    var _React$Children$toArr = React.Children.toArray(this.props.children),
        firstChild = _React$Children$toArr[0],
        secondChild = _React$Children$toArr[1];

    return this._portalNode ? /*#__PURE__*/React.createElement(React.Fragment, null, firstChild, this._renderPortal(secondChild)) : firstChild;
  };

  return Portal;
}(React.Component);

_defineProperty(Portal, "defaultProps", {
  renderTag: 'div',
  renderTo: null
});

_defineProperty(Portal, "contextType", ThemeContext);

export { Portal };